var catalog = [
  {partNumber:'CUM-ECU-6BT-221',name:'Cummins 6BT ECU Controller',category:'Engine Electronics',brand:'Cummins',price:1246,confidence:97,specs:'24V CAN 2.0B'},
  {partNumber:'JCB-PCB-9032',name:'JCB Controller PCB Module',category:'Controllers & Displays',brand:'JCB',price:890,confidence:95,specs:'Multi-layer board'},
  {partNumber:'CAT-ALT-140A-11',name:'Heavy Duty Alternator 140A',category:'Alternators & Starters',brand:'Caterpillar',price:456,confidence:94,specs:'Universal fit'},
  {partNumber:'JCB-HYD-PUMP-203',name:'JCB Hydraulic Pump Assembly',category:'Hydraulics & Gaskets',brand:'JCB',price:2340,confidence:93,specs:'High-pressure'},
  {partNumber:'CAT-SNS-C9-88',name:'Caterpillar C9 Pressure Sensor',category:'Sensors & Modules',brand:'Caterpillar',price:124,confidence:92,specs:'IP67'},
  {partNumber:'LT-LUBE-PUMP-71',name:'L&T Lubrication Control Pump',category:'Cooling & Lubrication',brand:'L&T',price:211,confidence:91,specs:'Adaptive flow'}
];

function scorePart(p,tokens){
  var s = p.confidence / 50;
  var h = (p.partNumber+' '+p.name+' '+p.category+' '+p.brand).toLowerCase();
  tokens.forEach(function(t){
    if(h.includes(t)) s+=4;
    if(p.partNumber.toLowerCase().includes(t)) s+=6;
    if(p.brand.toLowerCase().includes(t)) s+=3;
    if(p.category.toLowerCase().includes(t)) s+=2;
  });
  return s;
}

function searchCatalog(q){
  var t = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
  var r = catalog.map(function(p){return {p:p,s:scorePart(p,t)};}).sort(function(a,b){return b.s-a.s;}).filter(function(e){return e.s>3;}).slice(0,3).map(function(e){return e.p;});
  return r.length ? r : catalog.slice(0,3);
}

function money(v){ return '$'+v.toLocaleString(); }

document.addEventListener('DOMContentLoaded',function(){
  // Brand buttons
  document.querySelectorAll('.brand-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      window.location.href='/pages/czar-search?q='+encodeURIComponent(btn.textContent+' part');
    });
  });

  // Scroll arrows
  var prodLeft = document.getElementById('product-arrow-left');
  var prodRight = document.getElementById('product-arrow-right');
  var prodTrack = document.getElementById('product-scroll-track');
  if (prodLeft && prodTrack) prodLeft.addEventListener('click', function() {
    prodTrack.scrollBy({ left: -(window.innerWidth * 0.75), behavior: 'smooth' });
  });
  if (prodRight && prodTrack) prodRight.addEventListener('click', function() {
    prodTrack.scrollBy({ left: window.innerWidth * 0.75, behavior: 'smooth' });
  });

  var blogLeft = document.getElementById('blog-arrow-left');
  var blogRight = document.getElementById('blog-arrow-right');
  var blogTrack = document.getElementById('blog-scroll-track');
  if (blogLeft && blogTrack) blogLeft.addEventListener('click', function() {
    blogTrack.scrollBy({ left: -(window.innerWidth * 0.75), behavior: 'smooth' });
  });
  if (blogRight && blogTrack) blogRight.addEventListener('click', function() {
    blogTrack.scrollBy({ left: window.innerWidth * 0.75, behavior: 'smooth' });
  });

  // Hamburger / Mobile sidebar
  var hamburgerBtn = document.getElementById('hamburger-btn');
  var mobileSidebar = document.getElementById('mobile-sidebar');
  var sidebarOverlay = document.getElementById('sidebar-overlay');
  var sidebarClose = document.getElementById('sidebar-close');

  function openSidebar() {
    mobileSidebar.classList.add('open');
    sidebarOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    mobileSidebar.classList.remove('open');
    sidebarOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburgerBtn) hamburgerBtn.addEventListener('click', openSidebar);
  if (sidebarClose) sidebarClose.addEventListener('click', closeSidebar);
  if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);

  // Sidebar sub-group accordion
  document.querySelectorAll('.sidebar-group-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var items = this.nextElementSibling;
      items.classList.toggle('open');
    });
  });
});

// AI Pill
(function(){
  var pc=document.getElementById('ai-pill-collapsed');
  var pe=document.getElementById('ai-pill-expanded');
  var po=document.getElementById('ai-pill-orb');
  if (!pc || !pe) return;
  pc.addEventListener('click',function(){
    pc.style.display='none';
    pe.style.display='flex';
    setTimeout(function(){ document.getElementById('ai-pill-input').focus(); },50);
  });
  document.getElementById('ai-pill-close').addEventListener('click',function(){
    pe.style.display='none';
    pc.style.display='flex';
  });
  document.getElementById('ai-pill-form').addEventListener('submit',function(e){
    e.preventDefault();
    var q=document.getElementById('ai-pill-input').value.trim();
    if(!q)return;
    po.className='ai-pill-orb is-thinking';
    document.querySelector('.ai-pill-submit').textContent='Searching...';
    setTimeout(function(){ window.location.href='/pages/czar-search?q='+encodeURIComponent(q); },600);
  });
  document.querySelectorAll('.ai-pill-chip').forEach(function(c){
    c.addEventListener('click',function(){
      document.getElementById('ai-pill-input').value=c.textContent;
      document.getElementById('ai-pill-form').dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
    });
  });
})();

// Hero form submit
var heroForm = document.getElementById('hero-form');
if (heroForm) {
  heroForm.addEventListener('submit',function(e){
    e.preventDefault();
    var q=document.getElementById('hero-input').value.trim();
    if(!q)return;
    var orb=document.getElementById('hero-orb-wrap');
    if(orb)orb.setAttribute('data-state','thinking');
    setTimeout(function(){ window.location.href='/pages/czar-search?q='+encodeURIComponent(q); },600);
  });
}

// Hero brand pill clicks
document.querySelectorAll('.hero-brand-pill').forEach(function(p){
  p.addEventListener('click',function(){
    var q=p.textContent+' compatible part';
    document.getElementById('hero-input').value=q;
    document.getElementById('hero-form').dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
  });
});

// Hero Parallax + Counter Animations
(function () {
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var prefersReducedMotion = reduceMotionQuery.matches;

  function initHeroParallax() {
    var heroSection = document.querySelector('.hero-section');
    var parallaxTargets = document.querySelectorAll('.hero-parallax');
    var indicators = document.querySelectorAll('.hero-scroll-indicator, .scroll-indicator, [data-scroll-indicator]');
    if (!heroSection || !parallaxTargets.length) return;

    if (prefersReducedMotion) {
      parallaxTargets.forEach(function (el) { el.style.transform = 'none'; });
      indicators.forEach(function (indicator) { indicator.style.opacity = '1'; });
      return;
    }

    var ticking = false;
    var heroTop = 0;

    function refreshHeroTop() {
      heroTop = heroSection.offsetTop || 0;
    }

    function updateParallax() {
      ticking = false;
      var rect = heroSection.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var heroInView = rect.bottom > 0 && rect.top < viewportHeight;
      var translateY = 0;

      if (heroInView) {
        var relativeScroll = Math.max(0, window.scrollY - heroTop);
        translateY = relativeScroll * 0.3;
      }

      parallaxTargets.forEach(function (el) {
        el.style.transform = 'translateY(' + translateY.toFixed(2) + 'px)';
      });

      if (indicators.length) {
        var opacity = Math.max(0, 1 - Math.min(window.scrollY / 200, 1));
        indicators.forEach(function (indicator) {
          indicator.style.opacity = String(opacity);
        });
      }
    }

    function scheduleUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateParallax);
    }

    refreshHeroTop();
    updateParallax();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', function () {
      refreshHeroTop();
      scheduleUpdate();
    }, { passive: true });
  }

  function parseCounterMeta(valueText, fallbackTarget, fallbackSuffix) {
    var safeText = (valueText || '').trim();
    var numberMatch = safeText.match(/-?[\d,.]+(?:\.\d+)?/);
    var target = 0;
    var prefix = '';
    var suffix = '';
    var decimals = 0;

    if (numberMatch) {
      var rawNumber = numberMatch[0];
      var numericValue = Number(rawNumber.replace(/,/g, ''));
      if (Number.isFinite(numericValue)) target = numericValue;
      var index = numberMatch.index || 0;
      prefix = safeText.slice(0, index);
      suffix = safeText.slice(index + rawNumber.length);
      var decimalPart = rawNumber.replace(/,/g, '').split('.')[1];
      decimals = decimalPart ? decimalPart.length : 0;
    }

    if (Number.isFinite(fallbackTarget) && fallbackTarget > 0 && target === 0) {
      target = fallbackTarget;
      if (!suffix && fallbackSuffix) suffix = fallbackSuffix;
      if (!safeText || safeText === '0') {
        safeText = fallbackTarget.toLocaleString() + suffix;
      }
    }

    return {
      finalText: safeText || String(target),
      target: target,
      prefix: prefix,
      suffix: suffix,
      decimals: decimals
    };
  }

  function animateCounter(el, originalText) {
    var fallbackTarget = Number(el.getAttribute('data-target'));
    var fallbackSuffix = el.getAttribute('data-suffix') || '';
    var meta = parseCounterMeta(originalText, fallbackTarget, fallbackSuffix);
    if (!Number.isFinite(meta.target) || meta.target <= 0) {
      el.textContent = meta.finalText;
      el.setAttribute('data-counter-animated', 'true');
      return;
    }

    var duration = 2000;
    var startTime = null;
    el.classList.add('is-counting');

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var current = meta.target * progress;
      var numericText;
      if (meta.decimals > 0) {
        numericText = current.toLocaleString(undefined, {
          minimumFractionDigits: meta.decimals,
          maximumFractionDigits: meta.decimals
        });
      } else {
        numericText = Math.floor(current).toLocaleString();
      }
      el.textContent = meta.prefix + numericText + meta.suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }
      el.textContent = meta.finalText;
      el.classList.remove('is-counting');
      el.setAttribute('data-counter-animated', 'true');
    }

    requestAnimationFrame(step);
  }

  function detectExistingCounterAnimation(el, callback) {
    var baseline = el.textContent;
    var checks = 0;
    var changed = false;
    var probe = window.setInterval(function () {
      if (el.textContent !== baseline) changed = true;
      checks += 1;
      if (checks >= 4) {
        window.clearInterval(probe);
        callback(changed);
      }
    }, 120);
  }

  function initCounters() {
    var counters = document.querySelectorAll('.metrics-section .counter');
    if (!counters.length) return;

    counters.forEach(function (counter) {
      var originalText = (counter.textContent || '').trim();
      if ((!originalText || originalText === '0') && counter.hasAttribute('data-target')) {
        var target = Number(counter.getAttribute('data-target'));
        var suffix = counter.getAttribute('data-suffix') || '';
        if (Number.isFinite(target) && target > 0) {
          originalText = target.toLocaleString() + suffix;
        }
      }
      counter.setAttribute('data-counter-original', originalText);
      if (prefersReducedMotion) {
        counter.textContent = originalText;
        counter.setAttribute('data-counter-animated', 'true');
      }
    });

    if (prefersReducedMotion || typeof IntersectionObserver !== 'function') return;

    var counterObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var counter = entry.target;
        observer.unobserve(counter);
        if (counter.getAttribute('data-counter-animated') === 'true') return;
        detectExistingCounterAnimation(counter, function (hasAnimation) {
          if (hasAnimation) {
            counter.setAttribute('data-counter-animated', 'true');
            return;
          }
          animateCounter(counter, counter.getAttribute('data-counter-original') || counter.textContent.trim());
        });
      });
    }, { threshold: 0.3 });

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroParallax();
    initCounters();
  });
})();
